import {
  resetStateToDefault,
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils'
import moment from 'moment'
import { API } from 'src/services'

function fromBackend (whbRule) {
  function haveLimit (value) {
    return value !== -1
  }

  function formatDateToObject (date) {
    if (!date) return null
    return moment(date).toDate()
  }

  function formatWindowType () {
    const loaded = [
      {id: 'month', name: 'mês'},
      {id: 'week', name: 'semana'}
    ]
    return {
      loaded: loaded,
      selected: loaded.find(v => v.id === whbRule.windowType)
    }
  }

  // returns a object that we can use in Object.assign to update all state once
  return {
    accDailyLimit: whbRule.dailyLimitPerHourKind.some(haveLimit),
    dailyCheck: whbRule.dailyLimitPerHourKind.map(value => value === -1),

    accGeral: whbRule.generalLimitPerKindOfHora.some(haveLimit),
    generalCheck: whbRule.generalLimitPerKindOfHora.map(value => value === -1),

    accMonthlyLimit: whbRule.monthlyLimitPerKindOfHora.some(haveLimit),
    monthlyCheck: whbRule.monthlyLimitPerKindOfHora.map(value => value === -1),

    accPerc: whbRule.splitPerKindOfHour.some(value => value !== 0),

    timeCountType: whbRule.rollingWorkHoursBank ? 'movel' : 'fixo',

    // addPositiveCloser: whbRule.addPositiveCloser,
    allHoursConvertible: whbRule.allHoursConvertible,
    // allTimesCompensateOrder: whbRule.allTimesCompensateOrder,
    // arbtmsShouldntGoWhb: whbRule.arbtmsShouldntGoWhb,
    autoAccTm: whbRule.autoAccTm,
    autoCompStm: whbRule.autoCompStm,
    autoCompensate: whbRule.autoCompensate,
    code: whbRule.code,
    compensationPerHourKind: whbRule.compensationPerHourKind,
    // createOnDayOff: whbRule.createOnDayOff,
    dailyLimitPerHourKind: whbRule.dailyLimitPerHourKind.map(value => value === -1 ? 0 : value),
    dateOfBancoStart: formatDateToObject(whbRule.dateOfBancoStart),
    // deleted: whbRule.deleted,
    generalLimitPerKindOfHora: whbRule.generalLimitPerKindOfHora.map(value => value === -1 ? 0 : value),
    id: whbRule.id,
    isApproved: whbRule.isApproved,
    // lockRequest: whbRule.lockRequest,
    // locked: whbRule.locked,
    // lockedAt: whbRule.lockedAt,
    monthlyLimitPerKindOfHora: whbRule.monthlyLimitPerKindOfHora.map(value => value === -1 ? 0 : value),
    name: whbRule.name,
    negativeBalance: whbRule.negativeBalance,
    numberOfDaysToCompensation: whbRule.numberOfDaysToCompensation,
    partialAcc: whbRule.partialAcc,
    partialWindow: whbRule.partialWindow,
    removeLineMeasurement: whbRule.removeLineMeasurement,
    rollingWorkHoursBank: whbRule.rollingWorkHoursBank,
    showHoursDetails: whbRule.showHoursDetails,
    splitPerKindOfHour: whbRule.splitPerKindOfHour.map(x => (1 - x) * 100),
    // unilateralLock: whbRule.unilateralLock,
    windowExpirationCycle: whbRule.windowExpirationCycle,
    windowType: formatWindowType()
  }
}

function toBackEnd (state) {
  function rollingWorkHoursBank () {
    return state.timeCountType === 'movel'
  }

  function formatDateIsoString (date) {
    if (state.timeCountType === 'fixo') {
      return moment(date).toISOString()
    }
    return null
  }

  function splitPerKindOfHour () {
    if (!state.accPerc) {
      return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
    return state.splitPerKindOfHour.map(x => 1 - (x / 100))
  }

  function getLimits (checkName, stateName, noLimitCheckName) {
    // Se não foi selecionado, manda tudo "sem limite"
    if (!state[checkName]) {
      return [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1]
    }
    return state[stateName].map((value, index) => {
      // Se "Sem Limite" é verdadeiro, mapeia pra -1
      if (state[noLimitCheckName][index]) {
        return -1
      }
      // Caso contrario mapeia para o valor que deve ser
      return value
    })
  }

  const request = {
    allHoursConvertible: true,
    autoAccTm: state.autoAccTm,
    autoCompStm: state.autoCompStm,
    autoCompensate: state.autoCompensate,
    compensationPerHourKind: state.compensationPerHourKind,
    code: state.code,
    dailyLimitPerHourKind: getLimits('accDailyLimit', 'dailyLimitPerHourKind', 'dailyCheck'),
    dateOfBancoStart: formatDateIsoString(state.dateOfBancoStart),
    dateOfLastBancoReset: false,
    generalLimitPerKindOfHora: getLimits('accGeral', 'generalLimitPerKindOfHora', 'generalCheck'),
    isApproved: state.isApproved,
    monthlyLimitPerKindOfHora: getLimits('accMonthlyLimit', 'monthlyLimitPerKindOfHora', 'monthlyCheck'),
    name: state.name,
    negativeBalance: state.negativeBalance,
    numberOfDaysToCompensation: state.numberOfDaysToCompensation,
    partialAcc: state.partialAcc,
    rollingWorkHoursBank: rollingWorkHoursBank(),
    splitPerKindOfHour: splitPerKindOfHour(),
    windowExpirationCycle: state.windowExpirationCycle,
    windowType: state.windowType.selected ? state.windowType.selected.id : 'False'
  }

  if (state.id) request.id = state.id

  return request
}

function defaultState () {
  return {
    loading: false,
    accPerc: false,
    accDailyLimit: false,
    accMonthlyLimit: false,
    accGeral: false,
    timeCountType: 'fixo',

    // object to back end
    id: null,
    name: '',
    code: '',
    autoAccTm: true,
    autoCompStm: true,
    negativeBalance: true,
    isApproved: true,
    partialAcc: false,
    autoCompensate: false,
    showHoursDetails: false,
    windowType: {
      loaded: [
        {id: 'month', name: 'mês'},
        {id: 'week', name: 'semana'}
      ],
      selected: {id: 'month', name: 'mês'}
    },
    windowExpirationCycle: 6,
    dateOfBancoStart: null,
    numberOfDaysToCompensation: 90,
    compensationPerHourKind: Array(10).fill(1.0),
    splitPerKindOfHour: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
    dailyCheck: [true, true, true, true, true, true, true, true, true, true],
    dailyLimitPerHourKind: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    monthlyCheck: [true, true, true, true, true, true, true, true, true, true],
    monthlyLimitPerKindOfHora: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    generalCheck: [true, true, true, true, true, true, true, true, true, true],
    generalLimitPerKindOfHora: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  setFromState (state, {...company}) {
    Object.assign(state, company)
  },
  loading (state, payload) {
    state.loading = payload
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadWhbRules ({ commit }, whbRuleId) {
    commit('loading', true)

    const api = await API.whbRules.get({id: whbRuleId})

    commit('setFromState', {
      ...fromBackend(api.data.success[0])
    })

    commit('loading', false)
  },
  async save ({ state }) {
    const info = toBackEnd(state)

    // console.log(info)
    if (state.id) {
      await API.whbRules.save({id: state.id}, info)
    } else {
      await API.whbRules.save(info)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
